var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddAssigneeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 24,
    viewBox: "0 0 84 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 97"
  }, /*#__PURE__*/React.createElement("g", {
    id: "assignee"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 7",
    cx: 42,
    cy: 12,
    r: 11.5,
    stroke: "#3A3A3A",
    strokeOpacity: 0.3,
    strokeDasharray: "5 5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M47.0703 11.6094H42.4297V7.39062C42.4297 7.17488 42.2373 7 42 7C41.7627 7 41.5703 7.17488 41.5703 7.39062V11.6094H36.9297C36.6924 11.6094 36.5 11.7843 36.5 12C36.5 12.2157 36.6924 12.3906 36.9297 12.3906H41.5703V16.6094C41.5703 16.8251 41.7627 17 42 17C42.2373 17 42.4297 16.8251 42.4297 16.6094V12.3906H47.0703C47.3076 12.3906 47.5 12.2157 47.5 12C47.5 11.7843 47.3076 11.6094 47.0703 11.6094Z",
    fill: "#3A3A3A",
    fillOpacity: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddAssigneeIcon);
export default __webpack_public_path__ + "static/media/addAssigneeIcon.1709f6e03546e973610f010ea7c1f22f.svg";
export { ForwardRef as ReactComponent };